/**
 * Triggers a file download from the specified url.
 * @param {string} url - The name of the file when downloaded.
 */
function triggerDownload(url) {
    if (!url) {
        return;
    }

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute("target", "_blank");
    link.setAttribute("download", "");

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
}

/**
 * Triggers a file download
 * @param {string} id - The id of the file to be downloaded.
 * @param {string} filename - The name of the file when downloaded.
 */
export function download(id, filename) {
    let baseUrl = `/api/file/${id}`;

    if (filename) {
        baseUrl += `?filename=${encodeURIComponent(filename)}`;
    }

    triggerDownload(baseUrl);
}

export function downloadWithHighlights(id, filename, articleId) {
    let url = `/api/file/${id}/highlights`;

    if (articleId) {
        url += `?articleId=${articleId}`;
    }
    if (filename) {
        if (url.includes("?")) {
            url += `&filename=${encodeURIComponent(filename)}`;
        } else {
            url += `?filename=${encodeURIComponent(filename)}`;
        }
    }

    triggerDownload(url);
}

export function exportArticleWithFiles(articleId, projectId) {
    const url = `/api/project/${projectId}/article/${articleId}/export`;

    triggerDownload(url);
}

export default {
    download,
    triggerDownload,
    downloadWithHighlights,
    exportArticleWithFiles,
};
